import { createSelector } from 'reselect';

export const getState = (state) => state.contract;

export const getContract = createSelector(getState, ({ contract }) => contract);
